export function experimentMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      experimentId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}


export function experimentMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, experimentId: json.result.objectId}
  };
}

export function fixCreateExperimentId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixUpdateExperimentId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyExperiments(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      experimentId: resource.objectId,
    })),
  };
}